export default __webpack_public_path__ + "static/media/burning-fire.2a46fb0b.svg";